module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/ashinaga-campaign-1a3736ef564a5cad6ef9faeb338fef64.jpg";